import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { RadioButton } from 'components/atoms/inputs/RadioButton/RadioButton'
import styles from 'components/features/creditCard/creditCardPanes/paneComponents/CardPaymentMethodItem.styl'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { cardPaymentMethodsSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { CCPaymentMethod } from 'components/features/creditCard/creditCardStore/types'
import Flex from 'components/atoms/Flex/Flex'
import { getPaymentMethodTitle } from 'components/features/creditCard/creditCardStore/helpers'

const SelectPaymentMethodFields: FC<{}> = () => {
  const paymentMethods = useStoreSelector(cardPaymentMethodsSelector)
  const { formState: { errors }} = useFormContext()
  const renderCCPaymentMethodItem = (method: CCPaymentMethod, idx: number) => {
    const title = getPaymentMethodTitle(method)
    const { uid, number_last_digits } = method
    return (
      <li className={ styles.paymentMethod } key={ idx }>
        <RadioButton
          name='payment_method'
          label={ title }
          hint={ 'Ending in ' + number_last_digits }
          value={ uid }
          errors={ errors }
          withBorder
        />
      </li>
    )
  }

  if (!paymentMethods || paymentMethods.length < 1) {
    return (
      <li key='zeroState'>
        No payment methods added yet. <br />
      </li>
    )
  }

  return (
    <Flex component='ul'>
      { paymentMethods?.map(renderCCPaymentMethodItem) }
    </Flex>
  )
}

export default SelectPaymentMethodFields
